module.exports = __webpack_public_path__ + "img/icon-category.af9caf3e.svg";